import { useTheme } from "@mui/material/styles";
import { ChevronsUp } from "lucide-react";
import {
  useEffect
} from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router";
import {
  ScrollToTopButton,
  ScrollToTopButtonContent
} from "./ScrollToTopButton.styles";
import { useScrollAtBottom } from "../../hooks";

export function ScrollToTop(){
  const { pathname } = useLocation();
  const theme = useTheme();
  const { t } = useTranslation();
  const { isScrolling } = useScrollAtBottom({});

  useEffect(() => {
    // if the browser is able to handle scroll restoration
    // on its own steal control from it :D
    const canControlScrollRestoration = "scrollRestoration" in window.history;
    if (canControlScrollRestoration) {
      window.history.scrollRestoration = "manual";
    }

    window.scrollTo(0, 0);
  }, [pathname]);

  const scrollToTop = () => {
    window.scrollTo({
      behavior: "smooth",
      top: 0
    });
  };

  return (
    <ScrollToTopButton id="scrollToTopButton" tabIndex={ 0 } aria-label={ t("scroll_to_top") } onClick={ scrollToTop } theme={ theme } isVisible={ isScrolling }  >
      <ScrollToTopButtonContent theme={ theme }>
        <ChevronsUp aria-hidden={ true } size={ 24 } />
      </ScrollToTopButtonContent>
    </ScrollToTopButton>
  );
}

